import tingle from "tingle.js";
import "./js/scrollTrigger";
import "./js/loading";
import "./js/video-tingle";

(() => {
  // レシピのモーダル
  let panels = {};
  const btns = document.querySelectorAll(".js-recipeOpen");
  const btnsArray = Array.prototype.slice.call(btns, 0);
  btnsArray.forEach((ele) => {
    // モーダルの設定
    const id = ele.getAttribute("data-modal");
    panels[id] = new tingle.modal({
      closeMethods: ["overlay", "button", "escape"],
    });
    const modalTarget = document.querySelector(`#${id}`);
    if (modalTarget) {
      panels[id].setContent(modalTarget);
    }

    // クリック
    ele.addEventListener("click", (event) => {
      const tg = event.target.getAttribute("data-modal");
      if (panels[tg]) {
        panels[tg].open();
      }
    });
  });
})();

(() => {
  // レシピのボタン hover対応
  const recipeBtns = document.querySelectorAll(".c-recipe-btn");
  const recipeBtnsArray = Array.prototype.slice.call(recipeBtns, 0);
  recipeBtnsArray.forEach((ele) => {
    ele.addEventListener("touchstart", () => {
      return false;
    });
    ele.addEventListener("touchend", () => {
      return false;
    });
    ele.addEventListener("touchcancel", () => {
      return false;
    });
  });
})();
